(function () {
  function initHeroEffects() {
    document.documentElement.classList.add('he-v61-editable-controls-ready');

    var hero = document.querySelector('.he-premium-hero-v24');
    if (!hero) return;

    var oldGlow = hero.querySelector('.he-hero-sun-glow-v1');
    if (oldGlow) oldGlow.remove();

    hero.querySelectorAll('.he-hero-energy-flow-v3').forEach(function (el) {
      el.remove();
    });

    var oldStyle = document.getElementById('he-hero-sun-pulse-v1-style');
    if (oldStyle) oldStyle.remove();

    var oldV3Style = document.getElementById('he-hero-effects-v3-style');
    if (oldV3Style) oldV3Style.remove();

    var style = document.createElement('style');
    style.id = 'he-hero-effects-v3-style';
    style.textContent = [
      '.he-premium-hero-v24{position:relative;overflow:hidden;}',
      '.he-premium-hero-v24 .he-hero-sun-glow-v1{position:absolute;pointer-events:none;z-index:11;border-radius:50%;background:radial-gradient(circle,rgba(255,248,196,.96) 0%,rgba(255,222,86,.72) 24%,rgba(255,196,44,.36) 48%,rgba(255,179,0,.12) 64%,rgba(255,179,0,0) 76%);mix-blend-mode:screen;filter:blur(.2px);transform:translate(-50%,-50%) scale(.9);animation:heSunPulseV1 2.7s ease-in-out infinite;will-change:transform,opacity;}',
      '@keyframes heSunPulseV1{0%,100%{opacity:.56;transform:translate(-50%,-50%) scale(.90)}50%{opacity:1;transform:translate(-50%,-50%) scale(1.14)}}',
      '.he-premium-hero-v24 .he-hero-energy-flow-v3{position:absolute;inset:0;width:100%;height:100%;z-index:9;pointer-events:none;overflow:visible;}',
      '.he-premium-hero-v24 .he-energy-halo-v3{fill:none;stroke:#6cff79;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;opacity:.20;filter:blur(4px);}',
      '.he-premium-hero-v24 .he-energy-core-v3{fill:none;stroke:#74ff72;stroke-width:3.6;stroke-linecap:round;stroke-linejoin:round;opacity:.82;filter:drop-shadow(0 0 4px rgba(108,255,121,.70)) drop-shadow(0 0 9px rgba(108,255,121,.35));}',
      '.he-premium-hero-v24 .he-energy-runner-v3{fill:none;stroke:#f5fff2;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:3 13;opacity:.95;filter:drop-shadow(0 0 5px rgba(108,255,121,.75));animation:heEnergyRunV3 2.6s linear infinite;}',
      '.he-premium-hero-v24 .he-energy-node-v3{fill:#eaffd9;opacity:.96;filter:drop-shadow(0 0 5px rgba(108,255,121,.95)) drop-shadow(0 0 11px rgba(108,255,121,.55));animation:heEnergyNodeV3 2.2s ease-in-out infinite;transform-box:fill-box;transform-origin:center;}',
      '.he-premium-hero-v24 .he-energy-node-v3.n2{animation-delay:.55s}.he-premium-hero-v24 .he-energy-node-v3.n3{animation-delay:1.1s}.he-premium-hero-v24 .he-energy-node-v3.n4{animation-delay:1.55s}',
      '@keyframes heEnergyRunV3{from{stroke-dashoffset:0}to{stroke-dashoffset:-32}}',
      '@keyframes heEnergyNodeV3{0%,100%{opacity:.55;transform:scale(.88)}50%{opacity:1;transform:scale(1.18)}}',
      '.he-premium-hero-v24 .he-hero-energy-flow-v3--desktop{display:none;}',
      '.he-premium-hero-v24 .he-hero-compare-link{z-index:20!important;}',
      '.he-premium-hero-v24 a[href^="tel:"]{position:relative;z-index:20;}',
      '@media(max-width:749px){.he-premium-hero-v24 .he-hero-compare-link{top:53.7%!important}.he-premium-hero-v24 .he-hero-sun-glow-v1{left:14.5%;top:49.4%;width:84px;height:84px}.he-premium-hero-v24 .he-hero-energy-flow-v3--mobile{display:block}.he-premium-hero-v24 .he-hero-energy-flow-v3--desktop{display:none}}',
      '@media(min-width:750px){.he-premium-hero-v24 .he-hero-compare-link{left:4.2%!important;top:72.5%!important}.he-premium-hero-v24 .he-hero-sun-glow-v1{left:12%;top:74.6%;width:118px;height:118px}.he-premium-hero-v24 .he-hero-energy-flow-v3--mobile{display:none}.he-premium-hero-v24 .he-hero-energy-flow-v3--desktop{display:block}}',
      '@media(prefers-reduced-motion:reduce){.he-premium-hero-v24 .he-hero-sun-glow-v1,.he-premium-hero-v24 .he-energy-runner-v3,.he-premium-hero-v24 .he-energy-node-v3{animation:none!important}.he-premium-hero-v24 .he-hero-sun-glow-v1{opacity:.72}.he-premium-hero-v24 .he-energy-runner-v3{opacity:.72}}'
    ].join('');
    document.head.appendChild(style);

    var glow = document.createElement('span');
    glow.className = 'he-hero-sun-glow-v1';
    glow.setAttribute('aria-hidden', 'true');
    hero.appendChild(glow);

    function makeSvg(className, viewBox, routes, nodes) {
      var svgNS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('class', 'he-hero-energy-flow-v3 ' + className);
      svg.setAttribute('viewBox', viewBox);
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');

      var html = '';

      routes.forEach(function (d) {
        html += '<path class="he-energy-halo-v3" d="' + d + '"></path>';
        html += '<path class="he-energy-core-v3" d="' + d + '"></path>';
        html += '<path class="he-energy-runner-v3" d="' + d + '"></path>';
      });

      nodes.forEach(function (n, i) {
        html += '<circle class="he-energy-node-v3 n' + ((i % 4) + 1) + '" cx="' + n[0] + '" cy="' + n[1] + '" r="5.5"></circle>';
      });

      svg.innerHTML = html;
      hero.appendChild(svg);
    }

    makeSvg(
      'he-hero-energy-flow-v3--mobile',
      '0 0 1024 1536',
      [
        'M840 525 C838 590 830 645 824 705',
        'M824 705 C826 755 830 800 834 855'
      ],
      [
        [840,525],
        [824,705],
        [834,855]
      ]
    );

    makeSvg(
      'he-hero-energy-flow-v3--desktop',
      '0 0 1600 900',
      [
        'M1320 165 C1305 220 1290 285 1275 350',
        'M1275 350 C1272 415 1274 475 1278 535'
      ],
      [
        [1320,165],
        [1275,350],
        [1278,535]
      ]
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroEffects);
  } else {
    initHeroEffects();
  }

  document.addEventListener('shopify:section:load', initHeroEffects);
})();